//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 07.11.2016.
 */

(function () {
    
    'use strict';

    angular.module('container.widgets')
        .directive('srsngSelectBox', srsngSelectBox);           

    function srsngSelectBox($timeout) {

        return {
            restrict: 'E',
            scope: {
                ngModel: '=',
                ngChange: '&',
                inactive: '=',                    
                viewonly: '=',                    
                emptyOptionVisible: "@",
                emptyOptionText: '@',
                emptyOptionValue: '@',
                optionArray: '=',
                optionElementText: '@',
                optionElementValue: '@',
                optionElementModel: '@',
                search:  '@',
                validate: '@',
                searchExtension: '='
                                   
            },
            require: 'ngModel',
            templateUrl: 'container/ui/app/widgets/select-box/select-box.html',
            controller: controller,
            link: link
        };
       
        function controller($scope,$compile, $element, $attrs, $timeout) {
            $scope.emptyOptionVisible = $scope.emptyOptionVisible != undefined ? $scope.emptyOptionVisible : true; 
            $scope.emptyOptionText = $scope.emptyOptionText ||  "container.select.selectValue";
            $scope.emptyOptionValue = $scope.emptyOptionValue ||  undefined;
            if ($scope.emptyOptionValue == "null") $scope.emptyOptionValue = null;

            $scope.optionElementText = $scope.optionElementText != undefined ? $scope.optionElementText :  "text";
            $scope.optionElementValue = $scope.optionElementValue != undefined ? $scope.optionElementValue : "value";
            $scope.optionElementModel = $scope.optionElementModel != undefined ? $scope.optionElementModel : "value";          
            $scope.customOptionArray = $scope.optionArray != undefined ? $scope.optionArray.slice(0) : [];
            $scope.listVisible = false;
            $scope.hasSpecifiedOptionModel = true;   
            $scope.backupOptionArray = $scope.optionArray != undefined ? $scope.optionArray.slice(0) : [];
            $scope.search = $scope.search != undefined ? $scope.search : "";               
            $scope.noEntriesFound = false;
            $scope.noEntriesFoundValue = "No Matches";
            $scope.searchFinished = false;
            $scope.selectedIndex = 0;               
            $scope.validate = $scope.validate != undefined ? $scope.validate : true;               
            $scope.selectedOptionTextBackup = $scope.selectedOptionValue;

            init();
            
            function init() {                    
                $scope.hasSpecifiedOptionModel = $scope.optionElementModel != undefined && $scope.optionElementModel != '';
            }                

            $scope.getArrowIconUrl = () => {                    
                return `container/ui/assets/img/icons/system-icons-16x16/system-ic-arrow-drop-${$scope.listVisible ? 'up' : 'down'}-16x16.svg`;
            }; 

            $scope.setSelectValue = function(option) {                                                                  
                var value = $scope.getOptionValue(option);    

                $scope.search = $scope.getOptionText(option);
                
                $scope.selectedOptionText = $scope.search;
               
                $scope.ngModel = value; 
                $scope.listVisible = false;
                $scope.searchFinished = true;      
                if($scope.validate === true) {
                    $element.controller('ngModel').$setDirty();
                    $element.controller('ngModel').$setTouched();                
                    $timeout(function() {
                        $scope.ngChange();
                    });
                }
            };                
            
            $scope.getOptionText = function(option) {   
                if (!option) return undefined;
                if ($scope.optionElementText != undefined
                    && $scope.optionElementText != '')
                    return option[$scope.optionElementText];                        
                return option;
            }

            $scope.getOptionModel = function(option) {                         
                if (!option) return undefined;
                if ($scope.optionElementModel != undefined
                    && $scope.optionElementModel != '')
                    return option[$scope.optionElementModel];                        
                return option;
            }

            $scope.getOptionValue = function(option) {                   
                if (!option) return undefined;
                if ($scope.optionElementValue != undefined
                    && $scope.optionElementValue != ''
                    && option[$scope.optionElementValue] != undefined)
                    return option[$scope.optionElementValue];                        
                return option;
            } 

            $scope.$watch('search', function(newVal, oldVal) { 
                if(oldVal != newVal)
                {
                    if($scope.searchFinished === false)
                    {
                        $scope.ngModel = undefined;                        
                        $element.controller('ngModel').$setDirty();
                        $element.controller('ngModel').$setTouched();                
                        $timeout(function() {
                            $scope.ngChange();
                        });
                    }
                    
                    $scope.filter($scope.search);
                    if($scope.search != "" && $scope.searchFinished == false)
                    {
                        $scope.listVisible = true;
                    }
                    $scope.searchFinished = false;

                    $timeout(() => {
                        let scrollpaneElem = $('.srsng-select-box-options');
                        if (scrollpaneElem) {
                            $(scrollpaneElem).perfectScrollbar('update');
                            $(scrollpaneElem).trigger('ps-scroll-y');
                        }
                    });

                }
            });

            

            var _timeout;
            $scope.FilterByName = function() {
                if(_timeout) {
                    $timeout.cancel(_timeout);
                }
                _timeout = $timeout(function() {                        
                    $scope.filter($scope.search);
                    _timeout = null;
                }, 500);
            }

            $scope.setEmptyText = function() {
                $scope.selectedOptionTextBackup = $scope.selectedOptionValue;
                $scope.selectedOptionText = $scope.search == "" ? $scope.selectedOptionText ||  "container.select.selectValue" : $scope.search;
            }                

            $scope.filter = function(searchString)
            {             
                if(searchString !== undefined)
                {
                    $scope.selectedIndex = 0;
                    $scope.noEntriesFound  = false;     
                    if($scope.backupOptionArray.length < $scope.customOptionArray.length) {                        
                        $scope.backupOptionArray = $scope.customOptionArray; 
                    }
                    var input = $scope.backupOptionArray; 
                    var result = [];
                    var resultIndex = 0;
                   

                    angular.forEach(input, function(value, key) {   
                            var actual = ('' + $scope.getOptionText(value)).toLowerCase();                                     
                            if (actual.indexOf(searchString.toLowerCase()) !== -1) {
                                result[resultIndex] = value;  
                                resultIndex += 1;  
                            }
                         });                                          
                    if(result.length == 0)
                    {
                        $scope.noEntriesFound  = true;
                    }
                    $scope.customOptionArray = result;
                }
            }

            $scope.goToItem = (event) => {
                
                if(event.keyCode == 40 && $scope.selectedIndex < ($scope.customOptionArray.length - 1))
                {
                    $scope.selectedIndex += 1;                       
                }
                if(event.keyCode == 38 && $scope.selectedIndex != 0)
                {                        
                    $scope.selectedIndex -= 1;
                }                   
            }
        }

        function link(scope, element, attrs) {               
            scope.alt = 'altStyle' in attrs;

            scope.$watch('ngModel', newVal => {   
                let option = _.find(scope.backupOptionArray, function(option){ 
                    return scope.getOptionModel(option) == newVal;
                });
                if (option) {
                    scope.selectedOptionText = scope.getOptionText(option);
                    scope.search = scope.selectedOptionText;
                } else if (newVal !== undefined && scope.getOptionText(newVal) == scope.selectedOptionTextValue) {
                    scope.selectedOptionText = scope.getOptionText(newVal);
                    scope.search = scope.selectedOptionText;
                    
                }
                scope.searchFinished = true;

                if (newVal !== undefined) {
                    scope.listVisible = false;
                }
            });   

            if(scope.searchExtension != undefined)
            {
                angular.extend(scope.searchExtension, {
                    reset: function() {                                
                            scope.search = scope.selectedOptionTextBackup;                            
                    }
                });        
            }       

            scope.toggleList = (event) => {
                if (event.type !== "keypress") {
                  scope.noEntriesFound = false;
              
                  if (scope.backupOptionArray.length > Object.keys(scope.customOptionArray).length) {
                    const result = scope.backupOptionArray.filter(value =>
                      scope.search !== scope.getOptionText(value)
                    );
              
                    scope.noEntriesFound = result.length === 0;
                    scope.customOptionArray = result;
                  }
              
                  scope.noEntriesFound = Object.keys(scope.customOptionArray).length === 0;
                  scope.listVisible = !scope.listVisible;
              
                  if (scope.listVisible) {
                    scope.listContainerElm = angular.element(document.getElementsByClassName("srsng-select-box-options"));
                    scope.listContainerElm.width(element.children('.srsng-select-box').width());
                  }
                } else if (event.originalEvent.key === "Enter") {
                  const selectedItem = scope.customOptionArray[scope.selectedIndex];
                  scope.setSelectValue(selectedItem);
                } else {
                  scope.filter(scope.search);
                }
              };

            scope.$watchCollection('optionArray', function(newVal, oldVal) { 
                if (!scope.optionArray) return;
                scope.customOptionArray = scope.optionArray.slice(0);
                scope.backupOptionArray = scope.optionArray.slice(0);
                scope.customOptionArray.forEach(function(obj) {
                    if (!scope.listContainerElm) {
                        scope.listContainerElm = angular.element(document.getElementsByClassName("srsng-select-box-options"));
                    }  
                    if (_.isEqual(scope.getOptionModel(obj), scope.ngModel))
                    {
                        scope.selectedOptionText = scope.getOptionText(obj);     
                    }
                });
            });
        }
    } 
})();